// @flow
import React, { Component } from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import classNames from "classnames";

import FilterModal from "../../../ratecards/components/FilterModal";
import SortControls from "../../../ratecards/components/SortControls";
import { FILTER_COLUMN } from "../../../../models/Filter";
import SearchListItem from "./SearchListItem";
import SortIndicator from "../../../ratecards/components/SortIndicator";
import ToggleButton from "../../../ratecards/components/ToggleButton";
import SelectableItem from "../../../ratecards/components/SelectableItem";
import SelectableItemsList from "../../../ratecards/components/SelectableItemsList";
import InstantSearchBox from "../../../ratecards/components/InstantSearchBox";
import ListContainer from "../../../ratecards/components/ListContainer";
import ContainerSection from "../../../ratecards/components/ContainerSection";
import Pagination from "../../../ratecards/components/Pagination";
import LoadingIndicator from "../../../shared/LoadingIndicator";
import { SearchListStore } from "../../../../stores/mobx/interfaces/SearchListStore";
import LocationSelectNew from "../../../../components/selects/LocationSelectNew";
import { SingleDatePicker } from "../../../../components/SingleDatePicker";
import { Dropdown, MenuItem } from "react-bootstrap";
import Modal from "../../../ratecards/components/Modal";
import JobLabelFilter from "../../../filters/JobLabelFilter";
import JobTitleFilter from "../../../filters/JobTitleFilter";
import LocationFilter from "../../../filters/LocationFilter";
import RateTypeFilter from "../../../filters/RateTypeFilter";
import IndustryFilter from "../../../filters/IndustryFilter";

const CategoryCriteriaList = observer((props) => (
  <div>
    <SelectableItemsList className="overlap-tb-padding">
      {props.filterState.viewItems.map((item, i) => (
        <SelectableItem
          key={item.id}
          item={item}
          name="category-filter"
          value={item.category}
          selected={item.selected}
          onChange={props.filterState.setSelectedValue}
        >
          <div>{item.category}</div>
        </SelectableItem>
      ))}
    </SelectableItemsList>
    <ContainerSection className="info">
      <p className="text-muted text-x-small no-margin pull-right">
        <em>
          <strong>{props.filterState.selectedValuesCount} </strong>
          selected, <strong>{props.filterState.totalValuesCount} </strong>
          total
        </em>
      </p>
      <div className="clearfix" />
    </ContainerSection>
  </div>
));

class SearchList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      locationTitle: [
        {
          title: "Please Input keywords to Search...",
        },
      ],
      locations: [],
    };
    localStorage.setItem("isPtAdmin", true);
    this.changeCurrent = this.changeCurrent.bind(this);
    this.onLocationChange = this.onLocationChange.bind(this);
  }
  changeCurrent(value) {
    let store: SearchListStore = this.props.store;
    store.pagination.handleCurrentPage(value);
  }
  onLocationChange(location) {
    var result = location.map(function (a) {
      return a.locationId;
    });
    this.props.store.locationSearchFilter.onIdToLookForChange(result);
    this.setState({ locations: location });
  }
  render() {
    const store: SearchListStore = this.props.store;
    const maximumDate = new Date();

    const network = store.network;
    const fillContainer = this.props.fillContainer;
    const fixedHeight = this.props.fixedHeight;
    var selectedLocations = [];

    let listBodyStyles = {};
    if (fixedHeight) {
      listBodyStyles.height = fixedHeight;
      listBodyStyles.overflowY = "auto";
    }
    this.state.locations.map((e) => {
      if (e) {
        var object = {
          value: e.locationId,
          label: e.country,
        };
        selectedLocations.push(object);
      }
      return true;
    });

    let selectAllSection = null;
    let selectAllOnPageSection = (
      <nav className="header-left-nav">
        <div className="btn" onClick={store.selectAllPage}>
          Select All
        </div>
        <div className="btn" onClick={store.deselectAllPage}>
          Deselect All
        </div>
      </nav>
    );

    if (store.allOnPageSelected) {
      selectAllSection = (
        <div className="ratecards-list-select-all-section">
          <span>
            All &nbsp;
            <strong>{store.pagination.totalCount}</strong>
            &nbsp; Searches selected.{" "}
          </span>
          &nbsp;
          <span
            className="pt-link ratecards-all-items"
            key="clear-selections-link"
            onClick={store.clearAllSelections}
          >
            Clear all selections
          </span>
        </div>
      );
    }

    let tableLeftActionBar = null;
    if (store.isEditing) {
      tableLeftActionBar = (
        <nav className="header-left-nav">
          {store.allowMultipleItemSelection && selectAllOnPageSection}
        </nav>
      );
    } else {
      tableLeftActionBar = (
        <nav className="header-left-nav">
          <Dropdown bsStyle="default" title="Toggle All" noCaret id="dropdown-no-caret">
            <Dropdown.Toggle noCaret>Toggle All ▼</Dropdown.Toggle>
            <Dropdown.Menu>
              <MenuItem header>Searches</MenuItem>
              <MenuItem eventKey="1" onSelect={store.expandAllSearches}>
                Expand
              </MenuItem>
              <MenuItem eventKey="2" onSelect={store.collapseAllSearches}>
                Collapse
              </MenuItem>
            </Dropdown.Menu>
          </Dropdown>
        </nav>
      );
    }

    let tableContent = null;
    if (network.loading) {
      tableContent = <LoadingIndicator />;
    } else if (network.error) {
      tableContent = (
        <div className="pt-error-message fade-in">
          <h2>Error</h2>
          <pre>
            <code>{JSON.stringify(network.error, null, 2)}</code>
          </pre>
        </div>
      );
    } else if (store.searches.length === 0) {
      tableContent = <div className="pt-pad-item fade-in">No searches found...</div>;
    } else {
      if (store.isEditing) {
        tableContent = store.searches.map((search) => (
          <SearchListItem
            key={search.id}
            store={store}
            search={search}
            editing={store.isEditing}
            expandable={store.allowExpand}
            selected={search.viewState.selected}
            viewable={store.allowViewDetails}
            itemClick={(e) => store.toggleSelected(search)}
          />
        ));
      } else {
        tableContent = store.searches.map((search) => (
          <SearchListItem
            key={search.id}
            store={store}
            search={search}
            editing={store.isEditing}
            expandable={store.allowExpand}
            viewable={store.allowViewDetails}
            expanded={search.viewState.expanded}
            itemClick={(e) => store.toggleExpanded(search)}
          />
        ));
      }
    }

    var rateTypeList = (
      <ListContainer>
        {store.rateTypeFilter.viewItems.map((item) => (
          <ToggleButton
            key={item.id}
            large={true}
            item={item}
            type="radio"
            name="rate-type"
            value={item.value}
            selected={item.selected}
            onChange={store.rateTypeFilter.setSelectedValue}
          >
            {item.value}
          </ToggleButton>
        ))}
      </ListContainer>
    );

    var currencyTypeList = (
      <ListContainer>
        {store.currencyTypeArray.map((item) => (
          <ToggleButton
            key={item.id}
            large={true}
            item={item}
            type="radio"
            name="currency-type"
            value={item.value}
            selected={item.selected}
            onChange={(e) => store.changeCurrencyType(e)}
          >
            {item.value}
          </ToggleButton>
        ))}
      </ListContainer>
    );

    var curSelected = false;
    if (store.currencyType && store.currencyType !== "Default") {
      curSelected = true;
    }

    return (
      <div className="search-list">
        {store.jobTitleFilter && (
          <JobTitleFilter
            jobTitle={store.jobTitleFilter}
            network={store.jobTitleFilter.network.loading}
            instantSearchValue={store.jobTitleFilter.instantSearchValue}
            onInstantSearch={store.jobTitleFilter.onInstantSearch}
          />
        )}
        {store.jobLabelFilter && (
          <JobLabelFilter
            jobLabel={store.jobLabelFilter}
            network={store.jobLabelFilter.network.loading}
            instantSearchValue={store.jobLabelFilter.instantSearchValue}
            onInstantSearch={store.jobLabelFilter.onInstantSearch}
          />
        )}
        {store.rateTypeFilter && (
          <RateTypeFilter
            rateTypeFilter={store.rateTypeFilter}
            rateTypeList={rateTypeList}
            network={store.rateTypeFilter.network.loading}
          />
        )}
        {store.locationFilter && (
          <LocationFilter
            location={store.locationFilter}
            network={store.locationFilter.network.loading}
            instantSearchValue={store.locationFilter.instantSearchValue}
            onInstantSearch={store.locationFilter.onInstantSearch}
          />
        )}
        {store.industryFilter && (
          <IndustryFilter
            industryFilter={store.industryFilter}
            network={store.industryFilter.network.loading}
            instantSearchValue={store.industryFilter.instantSearchValue}
            onInstantSearch={store.industryFilter.onInstantSearch}
          />
        )}

        <Modal show={store.showCurrencyModal} onHide={store.hideCurrency}>
          <div className="container-section header">
            <h4>Change display currency</h4>
          </div>
          <ContainerSection>{currencyTypeList}</ContainerSection>
          <div className="container-section footer">
            <div className="pull-right">
              <button className="btn btn-lg btn-default" onClick={store.hideCurrency}>
                Cancel
              </button>
              <button className="btn btn-lg btn-green" onClick={store.changeCurrency}>
                Change
              </button>
            </div>
          </div>
        </Modal>

        {false && (
          <FilterModal filterState={store.categoryFilter}>
            {store.categoryFilter.network.loading && <LoadingIndicator />}
            {!store.categoryFilter.network.loading && (
              <div>
                <ContainerSection className="header overlap-t-padding">
                  <h4 className="pull-left">Category</h4>
                  <div className="pull-right">
                    <SortControls filterState={store.categoryFilter} />
                  </div>
                  <div className="clearfix" />
                </ContainerSection>
                <ContainerSection className="no-border">
                  <p>Filter by specific Category:</p>
                  <div>
                    <div className="pull-left">
                      <InstantSearchBox
                        onSearch={store.categoryFilter.onInstantSearch}
                        value={store.categoryFilter.instantSearchValue}
                      />
                    </div>
                    <div className="pull-right rc-center" style={{ height: 40 }}>
                      <button className="btn" onClick={store.categoryFilter.onSelectAll}>
                        Select All
                      </button>
                      <button
                        className="btn"
                        onClick={store.categoryFilter.onDeselectAll}
                      >
                        Deselect All
                      </button>
                    </div>
                    <div className="clearfix" />
                  </div>
                </ContainerSection>
                <CategoryCriteriaList filterState={store.categoryFilter} />
              </div>
            )}
          </FilterModal>
        )}

        {store.locationSearchFilter && (
          <FilterModal filterState={store.locationSearchFilter}>
            <div>
              <ContainerSection className="header overlap-t-padding">
                <h4 className="pull-left">Location</h4>
                <div className="clearfix" />
              </ContainerSection>
              <ContainerSection>
                <p>Search for:</p>
                <LocationSelectNew
                  locationTitle={(param) =>
                    this.props.rateSearchStore.locationTitle(param)
                  }
                  onChange={(locations) => this.onLocationChange(locations)}
                  value={selectedLocations}
                  className="location-filter"
                />
              </ContainerSection>
            </div>
          </FilterModal>
        )}
        {store.createdOnFilter && (
          <FilterModal filterState={store.createdOnFilter}>
            <div>
              <ContainerSection className="header overlap-t-padding">
                <h4 className="pull-left">Created On</h4>
                <div className="pull-right">
                  <SortControls
                    filterState={store.createdOnFilter}
                    sortType="numeric"
                    ascText="Sort Oldest First"
                    descText="Sort Newest First"
                  />
                </div>
                <div className="clearfix" />
              </ContainerSection>
              <ContainerSection>
                <p>Filter by a specific period:</p>
                <div className="pt-range-filter">
                  <div className="pt-range-filter__item">
                    <p>From:</p>
                    <SingleDatePicker
                      id="from_date"
                      date={store.createdOnFilter.fromDate}
                      numberOfMonths={1}
                      isOutsideRange={(day) => day.isAfter(maximumDate)}
                      focused={store.createdOnFilter.fromFocused}
                      onDateChange={store.createdOnFilter.fromDateChange}
                      onFocusChange={store.createdOnFilter.fromFocusedChange}
                    />
                  </div>
                  <div className="pt-range-filter__item">
                    <p>To:</p>
                    <SingleDatePicker
                      id="to_date"
                      date={store.createdOnFilter.toDate}
                      numberOfMonths={1}
                      isOutsideRange={() => false}
                      focused={store.createdOnFilter.toFocused}
                      onDateChange={store.createdOnFilter.toDateChange}
                      onFocusChange={store.createdOnFilter.toFocusedChange}
                    />
                  </div>
                </div>
              </ContainerSection>
            </div>
          </FilterModal>
        )}
        <header
          className={classNames("ratecards-table-header", {
            active: store.isFiltered,
          })}
        >
          {tableLeftActionBar}
          <nav className="header-right-nav">
            {store.isFiltered && (
              <div className="btn btn-yellow" onClick={store.clearFilters}>
                Clear All Filters & Sorts
              </div>
            )}
            {store.jobFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_LABEL}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_LABEL])}
                onClick={store.jobFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_LABEL}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_LABEL]}
                />
                Job Title<span> ▼</span>
              </ToggleButton>
            )}
            <ToggleButton
              borderless={true}
              name="search-list-filter"
              value={FILTER_COLUMN.CURRENCY_TYPE}
              selected={curSelected}
              onClick={store.showCurrency}
            >
              Currency<span> ▼</span>
            </ToggleButton>
            {store.rateTypeFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.RATE_TYPE}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.RATE_TYPE])}
                onClick={store.rateTypeFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.RATE_TYPE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.RATE_TYPE]}
                />
                Rate Type <span> ▼</span>
              </ToggleButton>
            )}
            {store.jobLabelFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_LABEL}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_LABEL])}
                onClick={store.jobLabelFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_LABEL}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_LABEL]}
                />
                Job Label<span> ▼</span>
              </ToggleButton>
            )}
            {store.jobTitleFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.JOB_TITLE}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.JOB_TITLE])}
                onClick={store.jobTitleFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.JOB_TITLE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.JOB_TITLE]}
                />
                Job Title <span> ▼</span>
              </ToggleButton>
            )}
            {store.locationFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.LOCATION}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.LOCATION])}
                onClick={store.locationFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.LOCATION}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.LOCATION]}
                />
                Location <span> ▼</span>
              </ToggleButton>
            )}
            {store.locationSearchFilter && (
              <ToggleButton
                borderless={true}
                name="rate-cards-filter"
                value={FILTER_COLUMN.LOCATION}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.LOCATION])}
                onClick={store.locationSearchFilter.onShowModal}
              >
                Location
                <span> ▼</span>
              </ToggleButton>
            )}
            {false && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.CATEGORY}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.CATEGORY])}
                onClick={store.categoryFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.CATEGORY}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.CATEGORY]}
                />
                Category <span> ▼</span>
              </ToggleButton>
            )}
            {store.industryFilter && (
              <ToggleButton
                borderless={true}
                name="search-list-filter"
                value={FILTER_COLUMN.INDUSTRY}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.INDUSTRY])}
                onClick={store.industryFilter.onShowModal}
              >
                <SortIndicator
                  sortColumn={FILTER_COLUMN.INDUSTRY}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.INDUSTRY]}
                />
                Industry <span> ▼</span>
              </ToggleButton>
            )}
            {store.createdOnFilter && (
              <ToggleButton
                borderless={true}
                name="rate-cards-filter"
                value={FILTER_COLUMN.DATE_RANGE}
                selected={Boolean(store.appliedFilters[FILTER_COLUMN.DATE_RANGE])}
                onClick={store.createdOnFilter.onShowModal}
              >
                <SortIndicator
                  sortType="numeric"
                  sortColumn={FILTER_COLUMN.DATE_RANGE}
                  sortsOrder={store.appliedSortsOrder}
                  sort={store.appliedSorts[FILTER_COLUMN.DATE_RANGE]}
                />
                Created On
                <span> ▼</span>
              </ToggleButton>
            )}
          </nav>
        </header>
        <div
          className={classNames("ratecards-table", {
            "ratecards-table-fill-container": fillContainer,
          })}
        >
          <div style={listBodyStyles}>
            {selectAllSection}
            {tableContent}
          </div>
        </div>
        {store.pagination.pageCount > 0 ? (
          <Pagination
            pageCount={store.pagination.pageCount}
            pagesToShow={store.pagination.maxPagesToShow}
            currentPage={store.pagination.currentPage}
            begin={store.pagination.begin}
            end={store.pagination.end}
            isEndRange={store.pagination.isEndRange}
            handleCurrentPage={this.changeCurrent}
            firstPage={store.pagination.firstPage}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}

SearchList.propTypes = {
  store: PropTypes.object.isRequired,
  fixedHeight: PropTypes.number,
  fillContainer: PropTypes.bool,
};

export default observer(SearchList);

// WEBPACK FOOTER //
// src/views/ratecards/components/SearchList.jsx
